import { FormControlLabel, Switch } from '@mui/material';
import { useTranslation } from 'next-i18next';
import { BoothLogosComponentInterface } from '../../../../../interfaces/pagebuilder';
import { PageBuilderSettingsSection, PageBuilderSettingsTable } from '../PageBuilderSettingsTable';

interface BoothLogoListSettingsTableInterface {
  component: BoothLogosComponentInterface;
  onChange: (c: BoothLogosComponentInterface) => void;
}

const BoothLogoListSettingsTable = ({ component, onChange }: BoothLogoListSettingsTableInterface) => {
  const { t } = useTranslation(['pagebuilder']);

  const settingSections: PageBuilderSettingsSection[] = [
    {
      settings: [
        {
          content: (
            <FormControlLabel
              className="w-full"
              control={<Switch checked={component.showBoothLogo} onChange={(e) => onChange({ ...component, showBoothLogo: e.target.checked })} />}
              label={t('pagebuilder:show-booth-logo')}
            />
          ),
        },
      ],
    },
  ];

  return <PageBuilderSettingsTable sections={settingSections} onChange={onChange} component={component} />;
};
export default BoothLogoListSettingsTable;
